import PaymentFormSubmitButton from "./PaymentFormSubmitButton";

export default PaymentFormSubmitButton;



// WEBPACK FOOTER //
// ./src/apps/payment/components/PaymentFormSubmitButton/index.js